import { render, staticRenderFns } from "./BetNumber.vue?vue&type=template&id=9fcb6f44&"
import script from "./BetNumber.vue?vue&type=script&lang=js&"
export * from "./BetNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports